// ABOUTME: API slice for shipper claims using RTK Query
// ABOUTME: Creates claims from an order and reads back the responses the shipper mailed

import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const CLAIM_BASE = "/claim";
const buildUrl = (endpoint) => CLAIM_BASE + endpoint;
const ApiName = "Claim";

const claimSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getClaims: builder.query({
            query: ({ args }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: `${ApiName}-List` }, { type: ApiName }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getClaims', ApiName),
        }),
        getClaim: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: ApiName, id: id }],
        }),
        createClaim: builder.mutation({
            query: info => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: info,
            }),
            invalidatesTags: () => [{ type: ApiName }, { type: `${ApiName}-List` }],
        }),
        getClaimCounts: builder.query({
            query: () => ({
                url: buildUrl(`/counts`),
                method: 'GET',
            }),
            providesTags: () => [{ type: `${ApiName}-List` }],
        }),
        releaseClaims: builder.mutation({
            query: info => ({
                url: buildUrl(`/release`),
                method: 'PUT',
                body: { claimIds: info.claimIds },
            }),
            invalidatesTags: () => [{ type: ApiName }, { type: `${ApiName}-List` }],
        }),
        updateClaimResponse: builder.mutation({
            query: info => ({
                url: buildUrl(`/response/${info.id}`),
                method: 'PUT',
                body: info,
            }),
            invalidatesTags: () => [{ type: ApiName }, { type: `${ApiName}-List` }],
        }),
    })
});

export const {
    useGetClaimsQuery,
    useGetClaimQuery,
    useCreateClaimMutation,
    useUpdateClaimResponseMutation,
    useGetClaimCountsQuery,
    useReleaseClaimsMutation
} = claimSlice;
